export const BLOG_INDEX_URL = "/ginnedmagazine";

export const buildBlogUrl = (url: string) =>
  url.startsWith(BLOG_INDEX_URL) ? url : `${BLOG_INDEX_URL}/${url}`;

export const cleanBlogUID = (uid: string) => uid.replace("/", "");
